import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { labPanels } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function LabsPreview() {
  const {
    brand
  } = useBrand();
  return <section className="bg-cream-light" data-id="element-63" data-mp="2le32wp2m18nt">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-24" data-id="element-64" data-mp="2hfnimsxwyee3">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-65" data-mp="2cfrcan1quavd">
          <img src={brand.images.labKit} alt={`A ${brand.name} at-home blood test kit`} className="aspect-[16/10] w-full rounded-brand object-cover" data-id="element-66" data-mp="2cdog1l9zzli7" />

          <div data-id="element-67" data-mp="22jo3iycdzdzg">
            <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-68" data-mp="1yfzv6dfxked5">Labs</p>
            <h2 className="mt-3 font-serif text-3xl font-bold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-69" data-mp="1yickxcrxjt0r">
              Guessing is not a treatment plan.
            </h2>
            <p className="mt-5 max-w-md text-base leading-relaxed text-ink-soft" data-id="element-70" data-mp="3susno3liop0v">
              Your blood panel comes with your membership. Do it at your kitchen table or at one of
              2,100 draw sites, and your doctor walks you through what it means before anyone talks
              about medication.
            </p>
            <ul className="mt-8 flex flex-col gap-3" data-id="element-71" data-mp="2mgqjiygjqm8u">
              {labPanels.map(panel => <li key={panel.name} className="flex items-start gap-5 rounded-brand border border-ink/10 bg-cream p-5" data-id="element-72" data-mp="3a6b2vigm3lin">
                  <span className="font-serif text-2xl font-bold text-brick" data-id="element-73" data-mp="3f4mgm4a12g65">{panel.markers}</span>
                  <div data-id="element-74" data-mp="31dr32eol3aw8">
                    <h3 className="text-sm font-medium text-ink" data-id="element-75" data-mp="35fkwq30d3emw">{panel.name}</h3>
                    <p className="mt-1 max-w-md text-sm leading-relaxed text-ink-muted" data-id="element-76" data-mp="35di1n4kcqvbb">
                      {panel.detail}
                    </p>
                  </div>
                </li>)}
            </ul>
            <Link to="/labs" className="group mt-7 inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-77" data-mp="bm803qcrywxc">
              See everything we test for
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-78" data-mp="2k8j2y1rfsue" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}